import React, { useState } from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'
import Box from '@material-ui/core/Box'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import DialogContent from '@material-ui/core/DialogContent'
import { IconButton, FormControlLabel, Checkbox } from '@material-ui/core'
import Button from 'src/components/sharedComponents/CustomButtons/Button'
import { IoCloseOutline } from 'react-icons/io5'
import { useStyles } from './styles'

const ModalConfigPage = ({
  open,
  partnerInfo,
  handleClose,
  bossesList,
  // regionsList,
  groupList,
  handleSaveInformation,
}) => {
  const [checked, setChecked] = useState(Boolean(partnerInfo.estado))
  const [selectedBoss, setSelectedBoss] = useState(null)
  const [selectedGroup, setSelectedGroup] = useState(null)
  // const [selectedRegion, setSelectedRegion] = useState('')

  const classes = useStyles()

  const handleActive = (event) => {
    setChecked(event.target.checked)
  }

  const onSave = () => {
    // eslint-disable-next-line no-unused-expressions
    selectedBoss &&
      (handleSaveInformation({
        ...partnerInfo,
        estado: Number(checked),
        idJefe: selectedBoss.id,
        idTerritorio: '280',
        idGrupo: selectedGroup.id,
      }),
      setSelectedBoss({}),
      setSelectedGroup(''),
      // setSelectedRegion(''),
        handleClose())
  }
  return (
    <Dialog open={open} onClose={() => handleClose()}>
      <DialogContent className={classes.dialogContent} >
        <ListItemIcon
          style={{
            display: 'flex',
            justifyContent: 'end',
            height: '30px',
            position: 'absolute',
            top: '0',
            right: '0',
          }}
        >
          <IconButton onClick={handleClose}>
            <IoCloseOutline
              style={{ fontSize: '32px', position: 'absolute', right: '6px', top:'6px' }}
            />
          </IconButton>
        </ListItemIcon>
        <DialogTitle className={classes.dialogTitle}>Responsable</DialogTitle>
        <Autocomplete
          autoComplete
          includeInputInList
          options={bossesList}
          onChange={(_, value) => {
            setSelectedBoss(value)
          }}
          getOptionLabel={(option) => option.name || ''}
          style={{
            width: '200px',
            margin: '0 auto 16px auto',
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Jefes"
            />
          )}
        />
        <DialogTitle className={classes.dialogTitle}>Regiones</DialogTitle>
        <TextField
          disabled
          label='País'
          style={{
            width: '200px',
            margin: '0 auto 16px auto',
          }}
        />
        {/* <Autocomplete
          autoComplete
          includeInputInList
          options={regionsList}
          defaultValue={partnerInfo.jefe}
          onChange={(_, value) => setSelectedRegion(value)}
          getOptionLabel={(option) => option.territorio || ''}
          style={{
            width: '200px',
            margin: '0 auto 16px auto',
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Regiones"
              disabled
            />
          )}
        /> */}
        <DialogTitle className={classes.dialogTitle}>Grupo</DialogTitle>
        <Autocomplete
          autoComplete
          includeInputInList
          options={groupList}
          onChange={(_, value) => {
            setSelectedGroup(value)
            // setValueAutocomplete(value)
          }}
          getOptionLabel={(option) => option.id || ''}
          style={{
            width: '200px',
            margin: '0 auto 16px auto',
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Grupos"
            />
          )}
        />
        <Box
          style={{
            width: '200px',
            margin: '0 auto',
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={checked}
                onChange={handleActive}
                name="active"
                color="primary"
              />
            }
            label="Activo"
          />
        </Box>
        <Button
          color={selectedBoss && selectedGroup? 'linkedin' : 'disabled'}
          style={{
            width: '120px',
            margin: '40px auto 16px auto',
          }}
          onClick={onSave}
          disabled={!(selectedBoss && selectedGroup)}
        >
          Guardar
        </Button>
      </DialogContent>
    </Dialog>
  )
}

export default ModalConfigPage
